// SEO utilities for dynamic meta tags
export const updatePageMeta = (meta = {}) => {
  const {
    title = 'LinguaLeap - Transform from Outsider to Insider',
    description = 'Master professional communication with LinguaLeap. Transform from outsider to insider with AI-powered business English training.',
    keywords = 'professional communication, business English, career advancement, workplace communication',
    image = 'https://images.unsplash.com/photo-1573164574572-cb89e39749b4?w=1200&h=630&fit=crop&crop=entropy&cs=srgb&fm=jpg&q=85',
    url = window.location.href,
    type = 'website'
  } = meta;

  // Update page title
  document.title = title;
  
  // Update meta tags
  updateMetaTag('name', 'description', description);
  updateMetaTag('name', 'keywords', keywords);
  updateMetaTag('property', 'og:title', title);
  updateMetaTag('property', 'og:description', description);
  updateMetaTag('property', 'og:image', image);
  updateMetaTag('property', 'og:url', url);
  updateMetaTag('property', 'og:type', type);
  updateMetaTag('property', 'twitter:title', title);
  updateMetaTag('property', 'twitter:description', description);
  updateMetaTag('property', 'twitter:image', image);
  updateMetaTag('name', 'twitter:card', 'summary_large_image');
  
  // Update canonical URL
  updateCanonicalUrl(url);
};

const updateMetaTag = (attribute, name, content) => {
  let element = document.querySelector(`meta[${attribute}="${name}"]`);
  
  if (!element) {
    element = document.createElement('meta');
    element.setAttribute(attribute, name);
    document.head.appendChild(element);
  }
  
  element.setAttribute('content', content);
};

const updateCanonicalUrl = (url) => {
  let canonical = document.querySelector('link[rel="canonical"]');
  
  if (!canonical) {
    canonical = document.createElement('link');
    canonical.setAttribute('rel', 'canonical');
    document.head.appendChild(canonical);
  }
  
  canonical.setAttribute('href', url);
};

// Page-specific meta configurations
export const PAGE_META = {
  home: {
    title: 'LinguaLeap - Transform from Outsider to Insider | Professional Communication Training',
    description: 'Master professional communication with LinguaLeap. Get better deals, promotions, and opportunities with AI-powered business English training.',
    keywords: 'professional communication, business English, career advancement, workplace communication, insider communication, professional development',
    url: 'https://www.lingua-leap.org/',
    image: 'https://images.unsplash.com/photo-1573164574572-cb89e39749b4?w=1200&h=630&fit=crop&crop=entropy&cs=srgb&fm=jpg&q=85'
  },
  social: {
    title: 'Social Media Marketing Content - LinguaLeap',
    description: 'Ready-to-use social media content for LinguaLeap marketing campaigns. LinkedIn posts, Instagram content, and more.',
    keywords: 'social media marketing, LinkedIn posts, Instagram content, professional communication marketing',
    url: 'https://www.lingua-leap.org/social',
    image: 'https://images.unsplash.com/photo-1517048676732-d65bc937f952?w=1200&h=630&fit=crop&crop=entropy&cs=srgb&fm=jpg&q=85'
  },
  static: {
    title: 'Marketing Content - LinguaLeap Professional Communication',
    description: 'Copy-ready marketing content for LinguaLeap including LinkedIn posts, banner ads, and social media templates.',
    keywords: 'marketing content, LinkedIn posts, banner ads, professional communication marketing templates',
    url: 'https://www.lingua-leap.org/static',
    image: 'https://images.pexels.com/photos/7821915/pexels-photo-7821915.jpeg?w=1200&h=630&fit=crop'
  }
};

// JSON-LD structured data
export const generateStructuredData = (type = 'website', data = {}) => {
  const baseData = {
    "@context": "https://schema.org",
    "@type": "WebApplication",
    "name": "LinguaLeap",
    "description": "Master professional communication with AI-powered business English training",
    "url": "https://www.lingua-leap.org",
    "applicationCategory": "EducationalApplication",
    "operatingSystem": "Web",
    "offers": {
      "@type": "Offer",
      "category": "Professional Development"
    },
    "creator": {
      "@type": "Organization",
      "name": "VantagePoints, Inc",
      "url": "https://www.youtube.com/@VentureBuildingSeries"
    }
  };

  return { ...baseData, ...data };
};

export const updateStructuredData = (data) => {
  const existingScript = document.querySelector('script[type="application/ld+json"]');
  
  if (existingScript) {
    existingScript.textContent = JSON.stringify(data);
  } else {
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify(data);
    document.head.appendChild(script);
  }
};